import { defaultTo } from 'ramda';
import { ITotalAmount } from '../../../redux/reducers';
import { IWriteOffInfoSchema } from '../../../repositories/monolith-python/entities/WriteOffInfoSchema';

export function mapTotalAmount(writeOffInfo?: IWriteOffInfoSchema | null): ITotalAmount {
  const { moneyAmount, pointsAmount } = writeOffInfo?.total || {};

  return {
    price: defaultTo(0, moneyAmount),
    auctionPoints: defaultTo(0, pointsAmount),
  };
}
